import {
  IconFileSpreadsheet,
  IconListCheck,
  IconChartArrowsVertical,
} from "@tabler/icons-react";
import { ReactComponent as Message } from "../iconColor/message-question.svg";
import { ReactComponent as Logout } from "../iconColor/arrow-right-to-bracket-outline.svg";
import { ReactComponent as User } from "../iconColor/user.svg";
import { ReactComponent as Users } from "../iconColor/users.svg";
import { ReactComponent as UsersAdmin } from "../iconColor/users-group-karbaran.svg";
import { ReactComponent as StoreOutline } from "../iconColor/store-outline.svg";
import { ReactComponent as ChartMixed } from "../iconColor/chart-mixed.svg";
import { ReactComponent as Vam30hand } from "../iconColor/vam30-beshkan.svg";
import { ReactComponent as Cart } from "../iconColor/cart.svg";
import { ReactComponent as LegalCheque } from "../iconColor/legal-cheque.svg";
import { ReactComponent as Cheque1 } from "../iconColor/cheque1.svg";
import { ReactComponent as Cheque2 } from "../iconColor/cheque2.svg";
import { ReactComponent as Esterdad } from "../iconColor/esterdad.svg";
import { ReactComponent as EsterdadG } from "../iconColor/esterdadG.svg";
import { ReactComponent as ChangeStatus } from "../iconColor/changeStatus.svg";
import { ReactComponent as ChangeStatusG } from "../iconColor/changestatus-g.svg";
import { ReactComponent as Review } from "../iconColor/review.svg";
import { ReactComponent as Contract } from "../iconColor/contract.svg";
import { ReactComponent as VosulUsers } from "../iconColor/vosulUsers.svg";
import { ReactComponent as Content } from "../iconColor/content.svg";
import { ReactComponent as Mali } from "../iconColor/mali.svg";
import { ReactComponent as Faq } from "../iconColor/faq.svg";
import { ReactComponent as Blogic } from "../iconColor/blogic.svg";
import { ReactComponent as Basic } from "../iconColor/basic.svg";
import { ReactComponent as WorkingH } from "../iconColor/workingh.svg";
import { ReactComponent as Loanic } from "../iconColor/loansic.svg";
import { ReactComponent as Bank } from "../iconColor/bank.svg";
import { ReactComponent as Consulting } from "../iconColor/Consulting.svg";
import { ReactComponent as Dashboard } from "../iconColor/dashboard.svg";
import { ReactComponent as Vosulicon } from "../iconColor/vosulicon.svg";
import { ReactComponent as VosuliconBlu } from "../iconColor/vosuliconBlu.svg";
import { ReactComponent as Tasvie } from "../iconColor/tasvie.svg";
import { ReactComponent as TasSam } from "../iconColor/tasvie-sam.svg";
import { ReactComponent as TasBlu } from "../iconColor/tasvieblue.svg";
import { ReactComponent as SendToBlu } from "../iconColor/sendtoblu.svg";
import { ReactComponent as Sandogh } from "../iconColor/sandogh.svg";
import { ReactComponent as ClosedFile } from "../iconColor/closed-file.svg";
import { ReactComponent as Reports } from "../iconColor/reports-all.svg";
import { useParams } from "react-router-dom";

const title = `${
  !localStorage.getItem("old_access_token")
    ? "خروج از حساب"
    : "بازگشت به پنل ادمین"
}`;

const useCreditorParams = () => {
  const params = useParams();
  return params?.creditor_uid;
};

const useCreditorMenus = () => {
  const creditorUid = useCreditorParams();

  return [
    {
      title: "داشبورد",
      src: `fa/creditor-dashboard/${creditorUid}`,
      srcForNewTab: `/fa/creditor-dashboard/${creditorUid}`,
      icon: <Dashboard />,
      disable: false,
    },
    {
      title: "تسویه بلو",
      src: `fa/creditor-dashboard/settlement/stores/${creditorUid}`,
      srcForNewTab: `/fa/creditor-dashboard/settlement/stores/${creditorUid}`,
      icon: <TasBlu />,
      disable: false,
      code: "SETTLEMENT_STORES",
    },
    {
      title: "سفارشات ",
      src: `fa/creditor-dashboard/orders/${creditorUid}`,
      srcForNewTab: `/fa/creditor-dashboard/orders/${creditorUid}`,
      icon: <Cart />,
      disable: false,
      code: "SUPERVISOR_ORDERS",
    },
    {
      title: "ارسال به بلو ",
      src: `fa/creditor-dashboard/send-bank/${creditorUid}`,
      srcForNewTab: `/fa/creditor-dashboard/send-bank/${creditorUid}`,
      icon: <SendToBlu />,
      disable: false,
      code: "CREDITOR_SEND_BANK",
    },
    {
      title: "پرونده",
      src: `fa/creditor-dashboard/applier/stores/${creditorUid}`,
      srcForNewTab: `/fa/creditor-dashboard/applier/stores/${creditorUid}`,
      cName: "sub-nav",
      icon: <IconListCheck />,
      disable: false,
      code: "RECEIVED_FILES",
    },
    {
      title: "تسویه حساب",
      src: `fa/creditor-dashboard/store-debts/${creditorUid}`,
      srcForNewTab: `/fa/creditor-dashboard/store-debts/${creditorUid}`,
      icon: <Tasvie />,
      disable: false,
      code: "STORE_DEBTS",
    },
    {
      title: "تسویه حساب (سام)",
      src: `fa/creditor-dashboard/store-debts-sam/${creditorUid}`,
      srcForNewTab: `/fa/creditor-dashboard/store-debts-sam/${creditorUid}`,
      icon: <TasSam />,
      disable: false,
      code: "STORE_DEBTS_SAM",
    },
    {
      title: "مالی",
      src: `fa/creditor-dashboard/financial/${creditorUid}`,
      srcForNewTab: `/fa/creditor-dashboard/financial/${creditorUid}`,
      icon: <Mali />,
      disable: false,
      code: "FINANCIAL",

      subMenus: [
        {
          title: "ارسال چک‌ها",
          src: `fa/creditor-dashboard/cheques-problem/${creditorUid}`,
          srcForNewTab: `/fa/creditor-dashboard/cheques-problem/${creditorUid}`,
          icon: <Cheque2 />,
          disable: false,
          code: "AT_FINANCIAL_CHEQUES",
        },
        {
          title: "تعیین وضعیت چک‌ها",
          src: `fa/creditor-dashboard/cheques-excel/${creditorUid}`,
          srcForNewTab: `/fa/creditor-dashboard/cheques-excel/${creditorUid}`,
          icon: <ChangeStatus />,
          disable: false,
          code: "IN_BANK_CHEQUES",
        },
        {
          title: "وضعیت چک‌ها ضمانت",
          src: `fa/creditor-dashboard/guarantee-cheques-states/${creditorUid}`,
          srcForNewTab: `/fa/creditor-dashboard/guarantee-cheques-states/${creditorUid}`,
          icon: <ChangeStatusG />,
          disable: false,
          code: "GUARANTEE_CHEQUES",
        },
        {
          title: "بررسی پرداخت‌ها",
          src: `fa/creditor-dashboard/transaction/${creditorUid}`,
          srcForNewTab: `/fa/creditor-dashboard/transaction/${creditorUid}`,
          icon: <Review />,
          disable: false,
          code: "FINANCIAL_PAYMENTS",
        },
        {
          title: "بررسی پرداخت کل بدهی",
          src: `fa/creditor-dashboard/total_debts/${creditorUid}`,
          srcForNewTab: `/fa/creditor-dashboard/total_debts/${creditorUid}`,
          icon: <Review />,
          disable: false,
          code: "FINANCIAL_TOTAL_PAYMENTS",
        },
      ],
    },
    {
      title: "وصول مطالبات",
      src: `fa/creditor-dashboard/debts/${creditorUid}`,
      srcForNewTab: `/fa/creditor-dashboard/debts/${creditorUid}`,
      icon: <Vosulicon />,
      disable: false,
      code: "FINANCIAL_DEBTS",
      subMenus: [
        {
          title: "پرونده ها",
          src: `fa/creditor-dashboard/debts/${creditorUid}`,
          srcForNewTab: `/fa/creditor-dashboard/debts/${creditorUid}`,
          icon: <IconListCheck />,
          disable: false,
          code: "DEBT_FILES",
        },
        {
          title: "صندوق",
          src: `fa/creditor-dashboard/tag-number/${creditorUid}`,
          srcForNewTab: `/fa/creditor-dashboard/tag-number/${creditorUid}`,
          icon: <Sandogh />,
          disable: false,
          code: "AT_FINANCIAL_DEBT_CHEQUES",
        },
        {
          title: "صندوق (ضمانت)",
          src: `fa/creditor-dashboard/guarantee-tag-number/${creditorUid}`,
          srcForNewTab: `/fa/creditor-dashboard/guarantee-tag-number/${creditorUid}`,
          icon: <Sandogh />,
          disable: false,
          code: "AT_FINANCIAL_DEBT_GUARANTEE",
        },
        {
          title: "تعیین وضعیت چک‌ها(بانک)",
          src: `fa/creditor-dashboard/returned-bank-cheques/${creditorUid}`,
          srcForNewTab: `/fa/creditor-dashboard/returned-bank-cheques/${creditorUid}`,
          icon: <ChangeStatus />,
          disable: false,
          code: "DEBT_CHEQUES_STATE",
        },
        {
          title: "صندوق ارسال به بانک",
          src: `fa/creditor-dashboard/cheques-financial/${creditorUid}`,
          srcForNewTab: `/fa/creditor-dashboard/cheques-financial/${creditorUid}`,
          icon: <Cheque2 />,
          disable: false,
          code: "RETURNED_BANK_DEBT_CHEQUES",
        },

        {
          title: "ارسال به بانک ضمانت",
          src: `fa/creditor-dashboard/guarantee-cheques-financial/${creditorUid}`,
          srcForNewTab: `/fa/creditor-dashboard/guarantee-cheques-financial/${creditorUid}`,
          icon: <Cheque2 />,
          disable: false,
          code: "RETURNED_BANK_DEBT_CHEQUES_GUARANTEES",
        },

        {
          title: "استرداد چک (اقساط)",
          src: `fa/creditor-dashboard/due-extradition-table/${creditorUid}`,
          srcForNewTab: `/fa/creditor-dashboard/due-extradition-table/${creditorUid}`,
          icon: <Esterdad />,
          disable: false,
          code: "CHEQUE_EXTRADITION_DUE",
        },
        {
          title: "استرداد چک (ضمانت)",
          src: `fa/creditor-dashboard/extradition-table/${creditorUid}`,
          srcForNewTab: `/fa/creditor-dashboard/extradition-table/${creditorUid}`,
          icon: <EsterdadG />,
          disable: false,
          code: "CHEQUE_EXTRADITION_GUARANTEE",
        },
        {
          title: "چک‌های حقوقی",
          src: `fa/creditor-dashboard/paycheques/${creditorUid}`,
          srcForNewTab: `/fa/creditor-dashboard/paycheques/${creditorUid}`,
          icon: <LegalCheque />,
          disable: false,
          code: "LEGAL_CLAIMS_CHEQUES",
        },
        {
          title: "پرونده‌های بسته شده",
          src: `fa/creditor-dashboard/closed-debts/${creditorUid}`,
          srcForNewTab: `/fa/creditor-dashboard/closed-debts/${creditorUid}`,
          icon: <ClosedFile />,
          disable: false,
          code: "CLOSED_DEBTS",
        },
        {
          title: "چک ضمانت کارشناس",
          src: `fa/creditor-dashboard/experts-gurantees/${creditorUid}`,
          srcForNewTab: `/fa/creditor-dashboard/experts-gurantees/${creditorUid}`,
          icon: <Cheque1 />,
          disable: false,
          code: "EXPERTS_GURANTEES",
        },
      ],
    },
    {
      title: "وصول مطالبات بلو",
      src: `fa/creditor-dashboard/blu-instalment-debts/${creditorUid}`,
      srcForNewTab: `/fa/creditor-dashboard/blu-instalment-debts/${creditorUid}`,
      icon: <VosuliconBlu />,
      disable: false,
      code: "BLU_FINANCIAL_DEBTS",
    },
    {
      title: "پرونده‌های بسته شده بلو",
      src: `fa/creditor-dashboard/blu-closed-debts/${creditorUid}`,
      srcForNewTab: `/fa/creditor-dashboard/blu-closed-debts/${creditorUid}`,
      icon: <ClosedFile />,
      disable: false,
      code: "BLU_CLOSED_DEBTS",
    },
    {
      title: "اظهارنامه بلو",
      src: `fa/creditor-dashboard/blu-instalment-legal-file/${creditorUid}`,
      srcForNewTab: `/fa/creditor-dashboard/blu-instalment-legal-file/${creditorUid}`,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
          width="20"
          height="20"
          strokeWidth="0.5"
        >
          <path d="M13 10l7.383 7.418c.823 .82 .823 2.148 0 2.967a2.11 2.11 0 0 1 -2.976 0l-7.407 -7.385"></path>
          <path d="M6 9l4 4"></path>
          <path d="M13 10l-4 -4"></path>
          <path d="M3 21h7"></path>
          <path d="M6.793 15.793l-3.586 -3.586a1 1 0 0 1 0 -1.414l2.293 -2.293l.5 .5l3 -3l-.5 -.5l2.293 -2.293a1 1 0 0 1 1.414 0l3.586 3.586a1 1 0 0 1 0 1.414l-2.293 2.293l-.5 -.5l-3 3l.5 .5l-2.293 2.293a1 1 0 0 1 -1.414 0z"></path>
        </svg>
      ),
      disable: false,
      code: "BLU_FINANCIAL_DEBTS_LEGAL",
    },
    {
      title: "گزارشات",
      src: `fa/creditor-dashboard/reports/${creditorUid}`,
      srcForNewTab: `/fa/creditor-dashboard/reports/${creditorUid}`,
      icon: <ChartMixed />,
      disable: false,
      code: "CREDITOR_REPORTS",
      subMenus: [
        {
          title: "گزارشات کلی",
          src: `fa/creditor-dashboard/reports/${creditorUid}`,
          srcForNewTab: `/fa/creditor-dashboard/reports/${creditorUid}`,
          icon: <Reports />,
          disable: false,
          code: "GENERAL_REPORTS",
        },
      ],
    },
    {
      title: "لیست اکسل‌ها",
      src: `fa/creditor-dashboard/excel-reports-table/${creditorUid}`,
      srcForNewTab: `/fa/creditor-dashboard/excel-reports-table/${creditorUid}`,
      icon: <IconFileSpreadsheet />,
      disable: false,
      code: "EXCEL_REPORTS_TABLE",
    },
  ];
};

export { useCreditorParams, useCreditorMenus };

export const AdminMenus = [
  {
    id: "dashboard",
    title: "داشبورد",
    src: "fa/admin-dashboard",
    srcForNewTab: "/fa/admin-dashboard",
    icon: <Dashboard />,
    disable: false,
  },
  {
    id: "orders",
    title: "سفارشات ",
    src: "fa/admin-dashboard/applier",
    srcForNewTab: "/fa/admin-dashboard/applier",
    icon: <Cart />,
    disable: false,
    code: "ORDERS",
  },
  {
    id: "users",
    title: "متقاضیان",
    src: "fa/admin-dashboard/users",
    srcForNewTab: "/fa/admin-dashboard/users",
    icon: <UsersAdmin />,
    disable: false,
    code: "USERS",
  },
  {
    id: "stores",
    title: "فروشگاه‌ها",
    src: "fa/admin-dashboard/store",
    srcForNewTab: "/fa/admin-dashboard/store",
    disable: false,
    icon: <StoreOutline />,
    code: "STORES",
  },
  {
    id: "contracts",
    title: "قراردادها",
    src: "fa/admin-dashboard/contracts",
    srcForNewTab: "/fa/admin-dashboard/contracts",
    icon: <Contract />,
    disable: false,
    code: "ADMIN_CONTRACTS",
  },
  {
    id: "leasing",
    title: "لیزینگ",
    src: "fa/admin-dashboard",
    srcForNewTab: "/fa/admin-dashboard",
    disable: false,
    icon: <Vosulicon />,
    code: "LEASING",
    subMenus: [
      {
        id: "financial-debts",
        title: "وصول مطالبات",
        src: "fa/admin-dashboard/debts",
        srcForNewTab: "/fa/admin-dashboard/debts",
        disable: false,
        icon: <Mali />,
        code: "DEBTS_FILES",
      },
      {
        id: "closed-debts",
        title: "پرونده‌های بسته شده",
        src: "fa/admin-dashboard/closed-debts",
        srcForNewTab: "/fa/admin-dashboard/closed-debts",
        disable: false,
        icon: <Mali />,
        code: "CLOSED_DEBTS",
      },
    ],
  },
  {
    id: "users-management",
    title: "کاربران",
    src: "fa/admin-dashboard/user",
    srcForNewTab: "/fa/admin-dashboard/user",
    disable: false,
    icon: <Users />,
    code: "USER",
    subMenus: [
      {
        id: "creditor-users",
        title: "کاربران اعتباردهنده‌ها",
        src: "fa/admin-dashboard/user/creditor-users",
        srcForNewTab: "/fa/admin-dashboard/user/creditor-users",
        icon: <VosulUsers />,
        disable: false,
        code: "CREDITOR_USERS",
      },
      {
        id: "vam30-users",
        title: "کاربران وامسی",
        src: "fa/admin-dashboard/user/vam30-users",
        srcForNewTab: "/fa/admin-dashboard/user/vam30-users",
        icon: <Vam30hand />,
        disable: false,
        code: "vam30_USERS",
      },
    ],
  },
  {
    id: "site-content",
    title: "محتوای سایت",
    src: "fa/admin-dashboard/blog",
    srcForNewTab: "/fa/admin-dashboard/blog",
    icon: <Content />,
    disable: false,
    code: "BLOG",
    subMenus: [
      {
        id: "faq",
        title: "سوالات متداول",
        src: "fa/admin-dashboard/common-questions",
        srcForNewTab: "/fa/admin-dashboard/common-questions",
        icon: <Faq />,
        disable: false,
        code: "COMMON_QUESTIONS",
      },
      {
        id: "fad",
        title: "سوالات روزانه",
        src: "fa/admin-dashboard/daily-questions",
        srcForNewTab: "/fa/admin-dashboard/daily-questions",
        icon: <Faq />,
        disable: false,
        code: "DAILY_QUESTIONS",
      },
      {
        id: "store-comments",
        title: "نظرات فروشگاه",
        src: "fa/admin-dashboard/comments",
        srcForNewTab: "/faadmin-dashboard/comments",
        icon: <Message />,
        disable: false,
        code: "STORE_COMMENTS",
      },
      {
        id: "blog",
        title: "بلاگ",
        src: "fa/admin-dashboard/blog",
        srcForNewTab: "/fa/admin-dashboard/blog",
        icon: <Blogic />,
        disable: false,
        code: "BASE_BLOG",
      },
    ],
  },
  {
    id: "base-info",
    title: "اطلاعات پایه",
    src: "fa/admin-dashboard/base-info",
    srcForNewTab: "/fa/admin-dashboard/base-info",
    icon: <Basic />,
    disable: false,
    code: "BASE_INFO",
    subMenus: [
      {
        id: "store-definitions",
        title: "تعاریف فروشگاه",
        src: "fa/admin-dashboard/base-info/store-definitions",
        srcForNewTab: "/fa/admin-dashboard/base-info/store-definitions",
        icon: <StoreOutline />,
        disable: false,
        code: "STORE_DEFINITIONS",
      },
      {
        id: "loans",
        title: "وام‌ها",
        src: "fa/admin-dashboard/base-info/loans",
        srcForNewTab: "/fa/admin-dashboard/base-info/loans",
        icon: <Loanic />,
        disable: false,
        code: "BASE_INFO_LOANS",
      },
      {
        id: "worktime",
        title: "ساعت کاری",
        src: "fa/admin-dashboard/worktime",
        srcForNewTab: "/fa/admin-dashboard/worktime",
        icon: <WorkingH />,
        disable: false,
        code: "BASE_INFO_WORKTIME",
      },
      {
        id: "banks-info",
        title: "بانک‌ها",
        src: "fa/admin-dashboard/base-info/banks",
        srcForNewTab: "/fa/admin-dashboard/base-info/banks",
        icon: <Bank />,
        disable: false,
        code: "BANK_MANAGER",
      },
    ],
  },
  {
    id: "reports",
    title: "گزارشات",
    src: "fa/admin-dashboard/reports",
    icon: <ChartMixed />,
    disable: false,
    code: "ADMIN_REPORTS",
  },
  {
    id: "excel-reports-table",
    title: "لیست اکسل‌ها",
    src: "fa/admin-dashboard/excel-reports-table",
    srcForNewTab: "/fa/admin-dashboard/excel-reports-table",
    icon: <IconFileSpreadsheet />,
    disable: false,
    code: "EXCEL_REPORTS_TABLE",
  },
  {
    id: "bi-panel",
    title: "هوش تجاری",
    src: "fa/admin-dashboard/bi-panel",
    srcForNewTab: "/fa/admin-dashboard/bi-panel",
    disable: false,
    icon: <IconChartArrowsVertical />,
    code: "BI_PANEL",
  },
  {
    id: "initial-store-table",
    title: "درخواست مشاوره",
    src: "fa/admin-dashboard/initial-store-table",
    srcForNewTab: "/fa/admin-dashboard/initial-store-table",
    icon: <Consulting />,
    disable: false,
    code: "INITIAL_STORE_TABLE",
  },
  {
    id: "message-manager",
    title: "مدیریت پیام‌ها",
    src: "fa/admin-dashboard/message",
    srcForNewTab: "/fa/admin-dashboard/message",
    icon: <Message />,
    disable: false,
    code: "ADMIN_DASHBOARD_MESSAGE",
  },
];

export const StoreMenus = [
  {
    title: "داشبورد",
    src: "fa/dashboard",
    srcForNewTab: "/fa/dashboard",
    icon: <Dashboard />,
    disable: false,
    code: "DASHBOARD",
  },
  {
    title: "پروفایل",
    src: "fa/dashboard/profile",
    srcForNewTab: "/fa/dashboard/profile",
    icon: <User />,
    disable: false,
    code: "STORE_PROFILE",
  },
  {
    title: "سفارشات",
    src: "fa/dashboard/orders",
    srcForNewTab: "/fa/dashboard/orders",
    icon: <Cart />,
    disable: false,
    code: "STORE_ORDERS",
  },
  {
    title: "قراردادها",
    src: "fa/dashboard/contracts",
    srcForNewTab: "/fa/dashboard/contracts",
    icon: <Contract />,
    disable: false,
    code: "CONTRACTS",
  },
  {
    title: "ثبت کاربر",
    src: "fa/dashboard/user-register",
    srcForNewTab: "/fa/dashboard/user-register",
    icon: <UsersAdmin />,
    disable: false,
    code: "STORE_USER_REGISTER",
  },
  {
    title: "تسویه‌ها",
    src: "fa/dashboard/settlements",
    srcForNewTab: "/fa/dashboard/settlements",
    icon: <Tasvie />,
    disable: false,
    code: "STORE_SETTLEMENTS",
  },
];

export const StaticMenus = [
  // {
  //   title: "تنظیمات ",
  //   src: "fa/creditor-dashboard/setting",
  //   srcForNewTab: "/fa/creditor-dashboard/setting",
  //   gap: true,
  //   icon: <Cog />,
  //   disable: true,
  // },
  // {
  //   title: "پشتیبانی و تیکت",
  //   src: "fa/creditor-dashboard/debts-details",
  //   srcForNewTab: "/fa/creditor-dashboard/debts-details",
  //   icon: <Headphones />,
  //   disable: true,
  // },
  {
    title: title,
    src: "fa/Logout",
    icon: <Logout />,
    disable: false,
  },
];
